angular.module('picmonicng').directive('browseClose', [
  'BrowseService',
  '$rootScope',
  function (BrowseService, $rootScope) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.bind('click', function () {
          scope.$apply(function () {
            if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') !== -1) {
              $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile'), 1);
            }

            BrowseService.close();
          });
        });
      },
    };
  },
]);
